import { MenuItem as MuiMenuItem, Stack } from '@mui/material';

import BaseAppLink from '@/components/AppLink';
import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const Container = styled(Stack)(({ theme }) => ({
  width: 260,
  minWidth: 260,
  height: '100%',
  backgroundColor: theme.palette.background.subtle,
  borderRight: getBorder(theme.palette.border.default),
}));

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(0),
  height: 32,

  '[data-cy="actions-menu"]': {
    display: 'none',
  },

  '&:hover [data-cy="actions-menu"]': {
    display: 'block',
  },
}));

const AppLink = styled(BaseAppLink)(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  textDecoration: 'none',
  color: theme.palette.text.default,

  '&:hover': {
    color: theme.palette.text.default,
    textDecoration: 'none',
  },
}));

const Section = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: getBorder(theme.palette.border.default),
}));

const TeamResource = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

const TeamResourceName = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export { Container, MenuItem, AppLink, Section, TeamResource, TeamResourceName };
